import { useMemo } from "react"

import { horizontalListSortingStrategy, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"

import { Draggable } from "./Draggable"

type DroppableProps = {
  children: React.ReactNode
  id: string
  itemIds: string[]
  direction?: "horizontal" | "vertical"
  emptyAreaElement?: React.ReactNode
  emptyAreaStyle?: React.CSSProperties
}

export const Droppable = ({
  children,
  itemIds,
  id,
  direction = "vertical",
  emptyAreaElement,
  emptyAreaStyle,
}: DroppableProps) => {
  const stableIds = (itemIds ?? []).join("___")
  const memoizedIds = useMemo(() => [...stableIds.split("___"), `${id}-empty`], [stableIds, id])

  return (
    <SortableContext
      id={id}
      strategy={direction === "vertical" ? verticalListSortingStrategy : horizontalListSortingStrategy}
      items={memoizedIds}
    >
      {children}
      {!itemIds || itemIds.length === 0 ? (
        <Draggable id={`${id}-empty`} placeholder>
          {emptyAreaElement ? (
            emptyAreaElement
          ) : (
            <div style={{ height: 10, width: "100%", ...(emptyAreaStyle ?? {}) }} />
          )}
        </Draggable>
      ) : null}
    </SortableContext>
  )
}
